/**
 * 模块说明：大目录分编管理
 */
import { Service } from '@/tools'
export class DirectorySubtitle<T extends TOrder.DirectorySubtitle> extends Service {
  constructor(path: string) {
    super()
    this.setPathPrefix(path)
  }

  private post2<P extends TCommon.ApiVersion = 'v1'>(url: `${P}/${keyof TOrder.DirectorySubtitle}`, data?: TCommon.Json, toast?: string) {
    return this.post(url, data, toast)
  }

  /* 编辑分编组  */
  updateSubtitle = <K extends T['ApiUpdateSubtitle']>(data?: K['req']): Promise<K['res']> => this.post2('v1/ApiUpdateSubtitle', data)

  /* 统编列表查询  */
  universalDetail = <K extends T['ApiUniversalDetail']>(data?: K['req']): Promise<K['res']> => this.post2('v1/ApiUniversalDetail', data)

  /* 统编存草稿  */
  unifiedSaveDraft = <K extends T['ApiUnifiedSaveDraft']>(data?: K['req']): Promise<K['res']> => this.post2('v1/ApiUnifiedSaveDraft', data)

  /* 统编提交  */
  unifiedCommit = <K extends T['ApiUnifiedCommit']>(data?: K['req']): Promise<K['res']> => this.post2('v1/ApiUnifiedCommit', data)

  /* 存草稿  */
  subtitleSaveDraft = <K extends T['ApiSubtitleSaveDraft']>(data?: K['req']): Promise<K['res']> => this.post2('v1/ApiSubtitleSaveDraft', data)

  /* 分编信息  */
  subtitleInfo = <K extends T['ApiSubtitleInfo']>(data?: K['req']): Promise<K['res']> => this.post2('v1/ApiSubtitleInfo', data)

  /* 待分编、分编中的目录期号下拉框  */
  subtitleDropDown = <K extends T['ApiSubtitleDropDown']>(data?: K['req']): Promise<K['res']> => this.post2('v1/ApiSubtitleDropDown', data)
  /* 待分编、分编中的目录期号下拉框  */
  subtitleDropDownPage = <K extends T['ApiSubtitleDropDownPage']>(data?: K['req']): Promise<K['res']> => this.post2('v1/ApiSubtitleDropDownPage', data)

  /* 分编详情  */
  subtitleDetail = <K extends T['ApiSubtitleDetail']>(data?: K['req']): Promise<K['res']> => this.post2('v1/ApiSubtitleDetail', data)

  /* 分编提交  */
  subtitleCommit = <K extends T['ApiSubtitleCommit']>(data?: K['req']): Promise<K['res']> => this.post2('v1/ApiSubtitleCommit', data)

  /* 查询目录下分编组列表信息  */
  queryDirectorySubtitle = <K extends T['ApiQueryDirectorySubtitle']>(data?: K['req']): Promise<K['res']> =>
    this.post2('v1/ApiQueryDirectorySubtitle', data)

  /* 已维护的多供应商列表  */
  maintainedBookSuppliers = <K extends T['ApiMaintainedBookSuppliers']>(data?: K['req']): Promise<K['res']> =>
    this.post2('v1/ApiMaintainedBookSuppliers', data)

  /* 目录分编  */
  directorySubtitle = <K extends T['ApiDirectorySubtitle']>(data?: K['req']): Promise<K['res']> => this.post2('v1/ApiDirectorySubtitle', data)

  /* 删除分编组  */
  deleteSubtitle = <K extends T['ApiDeleteSubtitle']>(data?: K['req']): Promise<K['res']> => this.post2('v1/ApiDeleteSubtitle', data)

  /* 目录再编列表查询  */
  againEditInfo = <K extends T['ApiAgainEditInfo']>(data?: K['req']): Promise<K['res']> => this.post2('v1/ApiAgainEditInfo', data)

  /* 目录再编提交  */
  againEditCommit = <K extends T['ApiAgainEditCommit']>(data?: K['req']): Promise<K['res']> => this.post2('v1/ApiAgainEditCommit', data)

  /* 新增分编组  */
  addSubtitle = <K extends T['ApiAddSubtitle']>(data?: K['req']): Promise<K['res']> => this.post2('v1/ApiAddSubtitle', data)

  /* 添加多供应商  */
  addBookSupplier = <K extends T['ApiAddBookSupplier']>(data?: K['req']): Promise<K['res']> => this.post2('v1/ApiAddBookSupplier', data)

  /* 分编组认领  */
  subtitleClaim = <K extends T['ApiSubtitleClaim']>(data?: K['req']): Promise<K['res']> => this.post2('v1/ApiSubtitleClaim', data)


}
